import { axiosGet, axiosPatch } from "../axios";
import { message } from "antd";

export const getNotifications = async ({
  pageNumber = 1,
  itemPerPage = 20,
}) => {
  try {
    const res = await axiosGet({
      path: `notification?&pageNumber=${pageNumber}&itemPerPage=${itemPerPage}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const updateNotification = async (id, payload) => {
  try {
    const res = await axiosPatch({
      path: `notification/${id}`,
      payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const markAllAsRead = async ({isCustomerNotification}) => {
  try {
    const res = await axiosGet({
      path: `notification/mark-read?isCustomerNotification=${isCustomerNotification}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};